import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import {
  CategoryEnrichmentProfile,
  SetCategoryProfilePayload
} from "../../recommendation.types";
import { requestSetEnrichmentProfile } from "./setEnrichmentProfile.request";

const useSetEnrichmentProfile = (
  options?: MutationOptions<
    CategoryEnrichmentProfile,
    ApiServiceError<ApiError>,
    SetCategoryProfilePayload
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestSetEnrichmentProfile,
    ...options,
    onSuccess: (data, variables, ctx) => {
      // Setting a branch to `none` erases the attributes already stored beneath
      // it, so the coverage list is stale as soon as this returns.
      void queryClient.invalidateQueries({
        queryKey: ["recommendation", "enrichment"]
      });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useSetEnrichmentProfile;
